import React from 'react';
import { CustomCellProperties } from 'alurkerja-ui';
import moment from 'moment';
import _ from 'lodash';
import { StackedProgressBar } from '@/components/shared/StackedProgressBar';
import { StatusColor } from '@/utils/constants/testRun';

interface StatusProgressProps {
  data: Array<{ total: number; percentage: number }>;
}

export const CustomCell = ({
  name,
  value,
  rowValue,
  defaultCell,
}: CustomCellProperties) => {
  if (name === 'test_case_id') {
    return <>{rowValue.test_case_id}</>;
  } else if (name === 'assignee_id') {
    return <>{rowValue.assignee ? rowValue.assignee.full_name : '-'}</>;
  } else if (name === 'created_at') {
    return <>{moment(value).format('DD MMMM YYYY')}</>;
  } else if (name === 'created_by') {
    return <>{rowValue.created_by ? rowValue.created_by.full_name : '-'}</>;
  } else if (name === 'status') {
    return (
      <>
        {rowValue.report ? (
          <StatusProgress data={rowValue.report.status || []} />
        ) : (
          '-'
        )}
      </>
    );
  }

  return defaultCell;
};

export const StatusProgress: React.FC<StatusProgressProps> = ({ data }) => {
  const rawLabels = Object.entries(data ?? {})
    .filter(([, value]) => value.total > 0)
    .map(([status]) => status);

  const progressDatasets = rawLabels.map(label => {
    const percentage = _.get(data, `${label}.percentage`, 0) * 100;
    const formattedPercentage = Number.isInteger(percentage)
      ? percentage
      : percentage.toFixed(2);

    return {
      value: percentage,
      color: StatusColor[label],
      tooltipText: `${label}: ${formattedPercentage}%`,
    };
  });

  return (
    <div className="w-[200px]">
      <StackedProgressBar
        max={30}
        values={progressDatasets}
        isTooltip
        height="0.5rem"
      />
    </div>
  );
};
